import Cytoscape from 'cytoscape';

// default layout options
const defaultColaLayoutOptions = {
  name: 'cola',

  animate: true, // whether to show the layout as it's running
  refresh: 1, // number of ticks per frame; higher is faster but more jerky
  maxSimulationTime: 4000, // max length in ms to run the layout
  ungrabifyWhileSimulating: false, // so you can't drag nodes during layout
  fit: true, // on every layout reposition of nodes, fit the viewport
  padding: 30, // padding around the simulation
  boundingBox: undefined, // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
  nodeDimensionsIncludeLabels: false, // whether labels should be included in determining the space used by a node

  // layout event callbacks
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ready: function () {}, // on layoutready
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  stop: function () {}, // on layoutstop

  // positioning options
  randomize: false, // use random node positions at beginning of layout
  avoidOverlap: true, // if true, prevents overlap of node bounding boxes
  handleDisconnected: true, // if true, avoids disconnected components from overlapping
  convergenceThreshold: 0.01, // when the alpha value (system energy) falls below this value, the layout stops
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  nodeSpacing: function (nod: string) {
    return 10;
  }, // extra spacing around nodes
  flow: undefined, // use DAG/tree flow layout if specified, e.g. { axis: 'y', minSeparation: 30 }
  alignment: undefined, // relative alignment constraints on nodes, e.g. {vertical: [[{node: node1, offset: 0}, {node: node2, offset: 5}]], horizontal: [[{node: node3}, {node: node4}], [{node: node5}, {node: node6}]]}
  gapInequalities: undefined, // list of inequality constraints for the gap between the nodes, e.g. [{"axis":"y", "left":node1, "right":node2, "gap":25}]
  centerGraph: true, // adjusts the node positions initially to center the graph (pass false if you want to start the layout from the current position)

  // different methods of specifying edge length
  // each can be a constant numerical value or a function like `function( edge ){ return 2; }`
  edgeLength: undefined, // sets edge length directly in simulation
  edgeSymDiffLength: undefined, // symmetric diff edge length in simulation
  edgeJaccardLength: undefined, // jaccard edge length in simulation

  // iterations of cola algorithm; uses default values on undefined
  unconstrIter: undefined, // unconstrained initial layout iterations
  userConstIter: undefined, // initial layout iterations with user-specified constraints
  allConstIter: undefined // initial layout iterations with all constraints including non-overlap
};

export function colaInitialLayoutOptions(): object {
  return {
    ...defaultColaLayoutOptions,

    animate: false,
    fit: false,
    padding: 0,

    randomize: true,
    centerGraph: true
  };
}

export function colaIncrementalLayoutOptions(): object {
  return {
    ...colaInitialLayoutOptions(),

    randomize: false,
    centerGraph: false,
    handleDisconnected: false
  };
}

export interface AlignmentConstraint {
  node: Cytoscape.CollectionReturnValue;
  offset: number;
}
export interface AlignmentConstraints {
  vertical: AlignmentConstraint[][];
  horizontal: AlignmentConstraint[][];
}
export interface GapInequalityConstraint {
  axis: 'x' | 'y';
  left: Cytoscape.CollectionReturnValue;
  right: Cytoscape.CollectionReturnValue;
  gap: number;
  equality?: boolean;
}
